<div class="auth-tests-container">
  <div class="card">
    <div class="card-header">
      <h3>Authentication Tests</h3>
      <p class="text-muted">Test authentication endpoints on both WebAPI and Reporting services.</p>
    </div>

    <div class="card-body">
      <!-- Control Panel -->
      <div class="control-panel mb-4">
        <!-- Test Buttons -->
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">WebAPI</h5>
              </div>
              <div class="card-body">
                <div class="d-grid gap-2">
                  <button
                    type="button"
                    class="btn btn-info"
                    (click)="testWebApiAuth()"
                    [disabled]="webApiAuthLoading" data-testid="auth-tests-test-auth">
                    <span *ngIf="webApiAuthLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <i class="fas fa-lock me-2" *ngIf="!webApiAuthLoading"></i>
                    Test Auth
                  </button>

                  <!-- WebAPI Auth Result -->
                  <div class="test-result mt-2" *ngIf="webApiAuthResult">
                    <div class="alert" [ngClass]="webApiAuthResult.success ? 'alert-success' : 'alert-danger'">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center mb-1">
                            <i [class]="webApiAuthResult.success ? 'fas fa-check-circle me-2' : 'fas fa-times-circle me-2'"></i>
                            <strong>{{ webApiAuthResult.success ? 'Success' : 'Failed' }}</strong>
                          </div>
                          <div class="auth-details">
                            <div class="mb-1">
                              <strong>Authenticated:</strong>
                              <span [ngClass]="webApiAuthResult.isAuthenticated ? 'text-success' : 'text-danger'">
                                {{ webApiAuthResult.isAuthenticated ? 'Yes' : 'No' }}
                              </span>
                            </div>
                            <div class="mb-1">
                              <strong>User:</strong>
                              <span class="text-info">{{ webApiAuthResult.userName || 'None' }}</span>
                            </div>
                            <div class="mb-1">
                              <strong>Claims:</strong>
                              <span class="text-primary">{{ webApiAuthResult.claimsCount || 0 }}</span>
                            </div>
                            <div class="mb-2" *ngIf="webApiAuthResult.details && webApiAuthResult.details.claims && webApiAuthResult.details.claims.length > 0">
                              <strong>Claim Details:</strong>
                              <div class="claims-list mt-1">
                                <div *ngFor="let claim of webApiAuthResult.details.claims" class="claim-item">
                                  <small class="text-muted">{{ claim.type }}:</small> <span class="text-dark">{{ claim.value }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <small class="text-muted">{{ webApiAuthResult.timestamp | date:'medium' }}</small>
                         </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Reporting Service</h5>
              </div>
              <div class="card-body">
                <div class="d-grid gap-2">
                  <button
                    type="button"
                    class="btn btn-info"
                    (click)="testReportingAuth()"
                    [disabled]="reportingAuthLoading" data-testid="auth-tests-reporting-service-test-auth">
                    <span *ngIf="reportingAuthLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <i class="fas fa-lock me-2" *ngIf="!reportingAuthLoading"></i>
                    Test Auth
                  </button>

                  <!-- Reporting Auth Result -->
                  <div class="test-result mt-2" *ngIf="reportingAuthResult">
                    <div class="alert" [ngClass]="reportingAuthResult.success ? 'alert-success' : 'alert-danger'">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center mb-1">
                            <i [class]="reportingAuthResult.success ? 'fas fa-check-circle me-2' : 'fas fa-times-circle me-2'"></i>
                            <strong>{{ reportingAuthResult.success ? 'Success' : 'Failed' }}</strong>
                          </div>
                          <div class="auth-details">
                            <div class="mb-1">
                              <strong>Authenticated:</strong>
                              <span [ngClass]="reportingAuthResult.isAuthenticated ? 'text-success' : 'text-danger'">
                                {{ reportingAuthResult.isAuthenticated ? 'Yes' : 'No' }}
                              </span>
                            </div>
                            <div class="mb-1">
                              <strong>User:</strong>
                              <span class="text-info">{{ reportingAuthResult.userName || 'None' }}</span>
                            </div>
                            <div class="mb-1">
                              <strong>Claims:</strong>
                              <span class="text-primary">{{ reportingAuthResult.claimsCount || 0 }}</span>
                            </div>
                            <div class="mb-2" *ngIf="reportingAuthResult.details && reportingAuthResult.details.claims && reportingAuthResult.details.claims.length > 0">
                              <strong>Claim Details:</strong>
                              <div class="claims-list mt-1">
                                <div *ngFor="let claim of reportingAuthResult.details.claims" class="claim-item">
                                  <small class="text-muted">{{ claim.type }}:</small> <span class="text-dark">{{ claim.value }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <small class="text-muted">{{ reportingAuthResult.timestamp | date:'medium' }}</small>
                         </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state text-center py-5" *ngIf="!webApiAuthResult && !reportingAuthResult">
        <i class="fas fa-lock text-muted" style="font-size: 3rem;"></i>
        <h4 class="text-muted mt-3">No Test Results</h4>
        <p class="text-muted">Click any of the test buttons above to execute authentication tests and view results.</p>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/auth-tests/auth-tests.component.html